import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { useAuth } from "../config/AuthContext";
import SEO, { seoConfig } from "../component/SEO";
import { toastedError, toastedSuccess } from "../config/toast";

const Verify = () => {
     const navigate = useNavigate();

     const { user, userData } = useAuth();


     const useCaseOptions = [
          "Personal Use",
          "Professional Work",
          "Startup / Company",
          "Freelancing",
          "Learning / Practice"
     ];

     const [form, setForm] = useState({
          birthday: "",
          instagram: "",
          twitter: "",
          useCase: ""
     });

     const handleChange = (e) => {
          const { name, value } = e.target;

          if (name === "instagram") {
               const cleanValue = value
                    .replace(/https?:\/\/(www\.)?instagram\.com\//, "") 
                    .replace(/@/g, "") 
                    .replace(/\s/g, ""); 

               setForm((prev) => ({ ...prev, [name]: cleanValue }));
          } else {
               setForm((prev) => ({ ...prev, [name]: value }));
          }
     };

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!form.useCase) {
               toastedError("Please select your purpose 🚀");
               return;
          }


          try {
               // ✅ update display name
               await updateProfile(user, { displayName: form.fullName });

               await setDoc(
                    doc(db, "users", user.uid),
                    {
                         ...form,
                         isProfileComplete: true,
                         createdAt: new Date(),
                    },
                    { merge: true }
               );

               navigate("/overview");
               toastedSuccess("Profile ready ✨ Let’s build something amazing");

          } catch (err) {
               toastedError(err);
               console.error(err);
          }
     };


     return (
          <>

               <SEO {...seoConfig.verify} />

               <div className="verify-fusion">
                    {/* Background Accent - No Cards */}
                    <div className="floating-elements">
                         <div className="el sphere" />
                         <div className="el cube" />
                         <div className="el torus" />
                         <div className="el triangle" />
                    </div>

                    <div className="content-wrapper">
                         <div className="form-header">
                              <h1> Welcome <span>{userData?.name || user?.displayName || "Captain"}</span> <br /> let’s set up your profile</h1>
                              <p className="sub-text">Let’s make your account feel personal ✨</p>
                         </div>

                         <form className="fusion-form" onSubmit={handleSubmit}>
                              <div className="row row-gap-5">
                                   <div className="col-12">
                                        <div className="fusion-input-wrapper">
                                             <label>Purpose <span>*</span></label>

                                             <div className="fusion-select">
                                                  {useCaseOptions.map((opt, i) => (
                                                       <div
                                                            key={i}
                                                            className={`fusion-option ${!form.useCase ? "error" : ""} ${form.useCase === opt ? "active" : ""}`}
                                                            onClick={() =>
                                                                 setForm((prev) => ({ ...prev, useCase: opt }))
                                                            }
                                                       >
                                                            {opt}
                                                       </div>
                                                  ))}
                                             </div>
                                        </div>
                                   </div>

                                   <div className="col-md-6">
                                        <div className="fusion-input-wrapper">
                                             <label>Birthday <span>*</span></label>
                                             <input
                                                  type="date"
                                                  name="birthday"
                                                  value={form["birthday"]}
                                                  onChange={handleChange}
                                                  placeholder="Enter birthday"
                                                  disabled={false}
                                                  required
                                             />
                                             <span className="focus-border"></span>
                                        </div>
                                   </div>

                                   <div className="col-md-6">
                                        <div className="fusion-input-wrapper">
                                             <label>Email</label>
                                             <input
                                                  type="email"
                                                  name="email"
                                                  value={userData?.email || user?.email}
                                                  placeholder="Enter email"
                                                  disabled={true}
                                             />
                                             <span className="focus-border"></span>
                                        </div>
                                   </div>

                                   <div className="col-md-6">
                                        <div className="fusion-input-wrapper">
                                             <label>Instagram  <span>*</span></label>

                                             <div className="input-with-prefix">
                                                  <span className="prefix">https://www.instagram.com/</span>

                                                  <input
                                                       type="text"
                                                       name="instagram"
                                                       value={form["instagram"]}
                                                       onChange={handleChange}
                                                       placeholder="username"
                                                       required
                                                  />
                                             </div>

                                             <span className="focus-border"></span>
                                        </div>
                                   </div>

                                   <div className="col-md-6">
                                        <div className="fusion-input-wrapper">
                                             <label>Twitter Optional</label>
                                             <input
                                                  type="text"
                                                  name="twitter"
                                                  value={form["twitter"]}
                                                  onChange={handleChange}
                                                  placeholder="Enter twitter Account"
                                                  disabled={false}
                                                  required={false}
                                             />
                                             <span className="focus-border"></span>
                                        </div>
                                   </div>


                              </div>

                              <div className="form-footer">
                                   <button type="submit" className="fusion-btn">
                                        Save & Continue
                                   </button>
                              </div>
                         </form>
                    </div>
               </div>
          </>

     );
};

export default Verify;